export const MODAL_NAME = 'INSURANCE_CART'
